import { useState } from "react";
import Joi from "joi-browser";
import Form from "V2.0/components/Form";

export default function EmailAddressSelect(props) {
  const { onSubmit, onCancel, emailAddresses } = props;
  const inputField = {
    identifier: "",
  };
  const [loading, setLoading] = useState(false);
  const template = [
    {
      name: "identifier",
      label: "Email Address",
      type: "select",
      options: ["(None selected)", ...emailAddresses].map(
        (emailAddress, idx) => {
          return {
            id: idx,
            value: emailAddress,
            label: emailAddress,
          };
        }
      ),
    },
  ];
  const schema = {
    identifier: Joi.string().required(),
  };

  return (
    <Form
      inputField={inputField}
      template={template}
      schema={schema}
      loading={loading}
      setLoading={setLoading}
      buttonInfo={{
        buttons: "2",
        primaryLabel: "Add",
        secondaryLabel: "Cancel",
      }}
      onSubmit={onSubmit}
      handleSecondary={onCancel}
    />
  );
}
